import React from 'react';

interface ProgressBarAnimationProps {
  width?: number;
  height?: number;
}

const ProgressBarAnimation: React.FC<ProgressBarAnimationProps> = ({
  width = 300,
  height = 4,
}) => {
  const uniqueId = `clipRoundedRect-${Math.random().toString(36).substr(2, 9)}`;
  const uniqueBarryId = `barry-${Math.random().toString(36).substr(2, 9)}`;
  const uniqueBarry2Id = `barry2-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <svg
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      preserveAspectRatio='none'
    >
      <defs>
        {/* Clip path that matches the background shape */}
        <clipPath id={uniqueId}>
          <rect
            x='0'
            y='0'
            width={width}
            height={height}
            rx={height / 2}
            ry={height / 2}
          />
        </clipPath>

        {/* Style for animation */}
        <style>
          {`
            @keyframes barAnim-${uniqueBarryId} {
              0% { transform: translate(-${width * 0.66}px) scale(1); }
              100%  { transform: translate(${width * 1.2}px) scale(0.2, 1); }
            }

            #${uniqueBarryId} {
              animation: barAnim-${uniqueBarryId} 1.2s ease-out infinite;
            }

            @keyframes barAnim-${uniqueBarry2Id} {
              0% { transform: translate(-${width * 0.66}px) scale(1); }
              100%  { transform: translate(${width * 1.2}px) scale(0.2, 1); }
            }

            #${uniqueBarry2Id} {
              animation: barAnim-${uniqueBarry2Id} 1.5s ease-out infinite;
            }
          `}
        </style>
      </defs>

      {/* Background with rounded corners */}
      <rect
        x='0'
        y='0'
        width={width}
        height={height}
        rx={height / 2}
        ry={height / 2}
        fill='#97D5FC'
      />

      {/* Animated bars, clipped to background shape */}
      <rect
        id={uniqueBarryId}
        x='0'
        y='0'
        width={width * 0.43}
        height={height}
        rx={height / 2}
        ry={height / 2}
        fill='#255B8F'
        clipPath={`url(#${uniqueId})`}
      />

      <rect
        id={uniqueBarry2Id}
        x='0'
        y='0'
        width={width * 0.43}
        height={height}
        rx={height / 2}
        ry={height / 2}
        fill='#255B8F'
        clipPath={`url(#${uniqueId})`}
      />
    </svg>
  );
};

export default ProgressBarAnimation;
